'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _select = require('../../redux/modules/select');

var _alert = require('../../redux/modules/alert');

var _action = require('../../redux/modules/action');

var _modal = require('../../redux/modules/modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    actions: state.action.actions,
    attr: state.action.attr,
    orderNumber: state.booking.orderNumber,
    selectShow: state.select.show,
    selectRef: state.select.ref,
    selected: state.select.selected
  };
}, {
  showAlert: _alert.show, loadActions: _action.load, setDNF: _action.setDNF,
  showReason: _modal.show, selectList: _select.selectList, show: _select.show,
  hide: _select.hide, setAttributes: _action.setAttributes, setAction: _action.setAction
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call.apply(_ref, [this].concat(args))), _this), _this.setActionAttr = function (evt) {
      var action = JSON.parse(evt.target.getAttribute('data-action'));
      _this.props.setAttributes(action);
    }, _this.showHideOption = function (evt) {
      var select = evt.target.getAttribute('data-select');
      var value = evt.target.getAttribute('data-value');

      _this.props.selectList(value);

      if (_this.props.selectShow && _this.props.selectRef === select) {
        _this.props.hide(select);
      } else {
        _this.props.show(select);
      }
      if (select === 'selectAction') {
        _this.setActionAttr(evt);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Select, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          styles = _props.styles,
          selected = _props.selected,
          selectShow = _props.selectShow;

      return _react2.default.createElement(
        'div',
        { onClick: this.showHideOption, className: styles.selectWrapper },
        _react2.default.createElement('input', { type: 'text', 'data-select': 'selectAction', ref: 'selectAction', placeholder: 'Select Action', className: 'form-control', value: selected || '', disabled: true }),
        _react2.default.createElement('div', { className: styles.arrowIcon, 'data-select': 'selectAction' }),
        _react2.default.cloneElement(children, (0, _extends3.default)({}, selectShow, this.showHideOption))
      );
    }
  }]);
  return Select;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  attr: _propTypes2.default.object,
  orderNumber: _propTypes2.default.string,
  showAlert: _propTypes2.default.func,
  showReason: _propTypes2.default.func,
  selectList: _propTypes2.default.func,
  selectShow: _propTypes2.default.bool,
  show: _propTypes2.default.func,
  hide: _propTypes2.default.func,
  setAttributes: _propTypes2.default.func,
  setAction: _propTypes2.default.func,
  selectRef: _propTypes2.default.string,
  styles: _propTypes2.default.object,
  selected: _propTypes2.default.string,
  onclick: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = Select;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/Select.js
// module id = 864
// module chunks = 0